import { render, staticRenderFns } from "./EdmList.vue?vue&type=template&id=0d3743c9&scoped=true&"
import script from "./EdmList.vue?vue&type=script&lang=js&"
export * from "./EdmList.vue?vue&type=script&lang=js&"
import style0 from "./EdmList.vue?vue&type=style&index=0&id=0d3743c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3743c9",
  null
  
)

export default component.exports